"use client";
import { useState, useEffect, useRef } from "react";

/**
 * Hook to get the countdown time
 * @param targetTime - The target time to countdown to
 * @returns - The countdown time
 */
function useCountdown(targetTime: string | number | Date) {
    const [remainingTime, setRemainingTime] = useState(0);
    const intervalTm = useRef<NodeJS.Timeout | null>(null);
    useEffect(() => {
        try {
            intervalTm.current = setInterval(() => {
                const nearestExpire = new Date(targetTime).getTime();
                const currentTime = new Date().getTime();
                const remainingTime = Math.max(nearestExpire - currentTime, 0);
                setRemainingTime(remainingTime);
            }, 1000);
        } catch (error) {
            console.log(error);
        }
        return () => {
            if (intervalTm.current) {
                clearInterval(intervalTm.current);
            }
        };
    }, [targetTime]);

    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
    return {
        days,
        hours,
        minutes,
        seconds,
        remainingTime,
    };
}

export default useCountdown;
